module.exports = __webpack_public_path__ + "mobile.d5840416.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/img/mobile.svg
 ** module id = 989
 ** module chunks = 0
 **/